export const TRY_AUTH = "TRY_AUTH";
export const AUTH_SET_TOKEN = "AUTH_SET_TOKEN";
export const USER_SET = "USER_SET";